/**
 * PATH: packages/ui/src/components/settings/profile-tab/FormInput.tsx
 * PURPOSE: Reusable form input with icon, label, and error display
 * WHY: Extracted from ProfileTab.tsx to keep files under 300 lines
 */

import { cn } from '../../../lib/utils'
import type { FormInputProps } from './profile-tab-types'

export function FormInput({
  label,
  name,
  value,
  onChange,
  type = 'text',
  placeholder,
  disabled,
  icon,
  error,
}: FormInputProps) {
  return (
    <div className="space-y-1.5">
      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300">
        {label}
      </label>
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
            {icon}
          </div>
        )}
        <input
          type={type}
          name={name}
          value={value}
          onChange={(e) => onChange(name, e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className={cn(
            'w-full px-3 py-2 rounded-lg text-sm transition-colors',
            'bg-white dark:bg-slate-800 border',
            error
              ? 'border-red-500 focus:ring-red-500/50'
              : 'border-slate-200 dark:border-slate-700 focus:ring-teal-500/50 focus:border-teal-500',
            'text-slate-900 dark:text-white placeholder-slate-400',
            'focus:outline-none focus:ring-2',
            icon && 'pl-10',
            disabled && 'opacity-60 cursor-not-allowed bg-slate-50 dark:bg-slate-900'
          )}
        />
      </div>
      {error && (
        <p className="text-xs text-red-500">{error}</p>
      )}
    </div>
  )
}
